import { t } from "i18next";
import * as z from "zod";

import {
  isValidPhoneE164,
  normalizePhone,
} from "@/core/utils/func/input-normalization";
import { STORE_STATUSES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de création / mise à jour d'un point de vente
 * (`POST /MerchantStores/add`, `PUT /MerchantStores/{id}`).
 * Factory mémoïsée sur la langue courante (règle projet).
 */
export const createMerchantStoreSchema = () =>
  z.object({
    merchantId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    name: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    address: z.string().trim().or(z.literal("")).optional(),
    phone: z
      .string()
      .transform((raw) => {
        const trimmed = raw.trim();
        return trimmed ? normalizePhone(trimmed) : "";
      })
      .refine((value) => value === "" || isValidPhoneE164(value), {
        message: t("invalidPhoneNumberError"),
      })
      .optional(),
    gpsLat: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .or(z.nan())
      .optional(),
    gpsLng: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .or(z.nan())
      .optional(),
    status: z.enum(STORE_STATUSES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
  });

export type MerchantStoreFormValues = z.infer<
  ReturnType<typeof createMerchantStoreSchema>
>;
